/**
 * Город задаёт смещение от UTC в ЧАСАХ (например, Москва = 3).
 * Бэкенд хранит время встречи в истинном UTC.
 */

/** Локальное (городское) date+time -> истинный UTC ISO (без миллисекунд). */
export function cityLocalToUtcIso (
  date: string, // 'YYYY-MM-DD'
  time: string, // 'HH:MM' | 'HH:MM:SS'
  offsetHours = 0,
): string {
  const normalizedTime = time.length === 5 ? `${ time }:00` : time;
  const wallClockAsUtcMs = new Date(`${ date }T${ normalizedTime }Z`).getTime();
  const utcMs = wallClockAsUtcMs - offsetHours * 3600000;

  return new Date(utcMs).toISOString().replace(/\.\d{3}Z$/, 'Z');
}

/**
 * Истинный UTC-инстант -> Date, который при чтении браузер-локальными
 * геттерами (getHours/Intl) показывает городское настенное время.
 * При offsetHours === 0 эквивалентно прежнему хаку рендера "UTC как настенное".
 */
export function utcToCityDate (
  utc: string | number | Date,
  offsetHours = 0,
): Date {
  const utcMs = new Date(utc).getTime();
  // смещение браузера берём для САМОГО инстанта встречи, а не для "сейчас",
  // иначе для браузеров с переходом на летнее время встреча в другом DST-периоде
  // сдвинется на час
  const browserOffsetMs = new Date(utcMs).getTimezoneOffset() * 60000;

  return new Date(utcMs + offsetHours * 3600000 + browserOffsetMs);
}
